import {Component, h} from 'preact';
import Icon from '@components/common/Icon';
import PickList from '@components/common/PickList';
import AddressBookItem from './AddressBookItem';

const HOVER_CLASSES = 'border border-transparent border-solid t-border-color t-duration-short hover:border-sky-blue cursor-pointer';
const ITEMS_CLASSES = 'py-3 px-4 mt-4 rounded bg-near-white';

class AddressBook extends Component {
    static defaultProps = {
        itemIdProp: 'id',
        itemType: 'address',
        groupId: 'addressList',
        label: 'Select address',
        addresses: [],
        defaultAddress: null,
        onAddressChange: () => {}
    };

    render ( props ) {
        const isEmpty = !props.addresses || !props.addresses.length;

        return (
            <PickList
                groupId={props.groupId}
                itemIdProp={props.itemIdProp}
                itemType={props.itemType}
                list={props.addresses}
                defaultSelection={props.defaultAddress}
                allowAddItem={false}
                onItemChange={props.onAddressChange}>
                {pickListProps => (
                    <div>
                        <div className="flex items-center w-full justify-between">
                            <h2 className="text-lg font-normal">{props.label}</h2>
                            <PickList.EditAction/>
                        </div>
                        {isEmpty
                            ? <p className="mt-2 flex items-center">
                                <Icon.ui name="report-problem-triangle" className="text-lg mr-2"/>
                                No addresses available
                            </p>
                            : <div>
                                <PickList.Selection
                                    className={ITEMS_CLASSES}
                                    interactionClassName={HOVER_CLASSES}
                                    itemRenderer={AddressBookItem}/>
                                <PickList.List
                                    enableSearchAtCount={9}
                                    maxResultCount={6}
                                    searchPlaceholder="e.g. 984 Sterling; Dallas TX; 90255"
                                    queryProps={['address1', 'address2', 'city', 'state', 'postalCode']}
                                    itemRenderer={props => <AddressBookItem {...props} className="py-3 px-4"/>}/>
                            </div>
                        }

                    </div>
                )}
            </PickList>
        );
    }
}

export default AddressBook;